import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IEditSurveyPayload extends ISagaCb {
    surId: string
    data: any
}

export interface IEditSurveyState {
    status: string
    data: any
    errors: any
}

const initialState: IEditSurveyState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editSurvey = createSlice({
    name: 'survey/editSurvey',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditSurveyPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editSurveyActions = editSurvey.actions
export default editSurvey.reducer
